import React from 'react';

import './ToolbarFilterFundings.less';

export default function ToolbarFilterFundings({ selectedFundings, onChange }) {
  const handleChange = (e) => {
    const { value } = e.target;
    if (selectedFundings.includes(value)) {
      if (selectedFundings.length > 1) onChange((prev) => prev.filter((v) => v !== value));
    } else onChange((prev) => [...prev, value]);
  };

  return (
    <div className="fundings-checkboxes">
      <label>
        <input
          type="checkbox"
          value="base"
          onChange={handleChange}
          checked={selectedFundings.includes('base')}
        />
        <span className="tag">базовая</span>
      </label>
      <label>
        <input
          type="checkbox"
          value="special"
          onChange={handleChange}
          checked={selectedFundings.includes('special')}
        />
        <span className="tag">специальная</span>
      </label>
    </div>
  );
}
